<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row v-if="tieneAccesoReporteSatisfaccion">
      <v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title class="text-subtitle-1">
					  {{ modoSoloAvance ? 'Avance encuesta de satisfacción' : 'Encuesta de satisfacción' }}
					  <v-spacer></v-spacer>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="teal"
							dark
							:disabled="!avancePorSucursal.length || cargar"
							@click="dialogAvanceSucursal = true"
							small
							tile
							class="mr-2"
						>
							<v-icon small left>mdi-store-marker</v-icon>
							Reporte sucursal
						</v-btn>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="success"
							dark
							:disabled="!tieneDatosReporte || cargar"
							@click="exportarExcelReporte()"
							small
							tile
							class="mr-2"
						>
							<v-icon small left>mdi-microsoft-excel</v-icon>
							Excel
						</v-btn>
	      		<v-btn
							color="primary"
							dark
							@click="initialize()"
							small
							tile
						>
							Actualizar
						</v-btn>
					</v-card-title>
					<v-card-text >

		      	<v-row>
		      		<v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  item-text="ciclo"
                  item-value="id_ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
              	<v-radio-group
						      v-model="opEscuela"
						      row
						    >
						      <v-radio
						        label="Inbi"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Fast"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
              </v-col>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroPlantel"
                  :items="planteles"
                  label="Sucursal"
                  item-text="plantel"
                  item-value="id_plantel"
                  :disabled="!ciclo"
                >
                </v-autocomplete>
              </v-col>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroNivelReporte"
                  :items="niveles"
                  label="Nivel"
                  item-text="nivel"
                  item-value="id_nivel"
                  :disabled="!ciclo"
                >
                </v-autocomplete>
              </v-col>
		      		<v-spacer></v-spacer>
							<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="pb-0">
			          <v-text-field
			            v-model="search"
			            dense
			            filled
			            label="Buscar"
			            append-icon="mdi-magnify"
			          ></v-text-field>  
			        </v-col>
		      	</v-row>

						<v-row v-if="!modoSoloAvance" class="mb-2">
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card :color="semaforoPromedioGeneral.background" class="pa-3 resumen-card" flat>
									<v-icon :color="semaforoPromedioGeneral.color" size="28" class="mb-1 d-block text-center">mdi-traffic-light</v-icon>
									<div class="d-flex align-center justify-center text-h5 font-weight-bold">
										<v-icon small :color="semaforoPromedioGeneral.color" class="mr-2">mdi-circle</v-icon>
										{{ promedioGeneralDisplay }}
									</div>
									<div class="text-caption text-center">Promedio general</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="blue darken-2" size="28" class="mb-1 d-block text-center">mdi-account-group</v-icon>
									<div class="text-h5 font-weight-bold text-center">{{ porcentajeParticipacionDisplay }}%</div>
									<div class="text-caption text-center">Participación</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="red lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="red darken-2" size="28" class="mb-1 d-block text-center">mdi-alert-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ peorCategoriaDisplay }}</div>
									<div class="text-caption text-center">Peor categoría</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="green darken-2" size="28" class="mb-1 d-block text-center">mdi-star-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ mejorCategoriaDisplay }}</div>
									<div class="text-caption text-center">Mejor categoría</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="orange darken-2" size="28" class="mb-1 d-block text-center">mdi-map-marker-alert</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ sucursalCriticaDisplay }}</div>
									<div class="text-caption text-center">Sucursal crítica</div>
								</v-card>
							</v-col>
						</v-row>

		        <v-tabs
		          v-if="!modoSoloAvance"
		          v-model="tab"
		          dense
		          align-with-title
		        >
		          <v-tabs-slider></v-tabs-slider>

		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Nivel y Cat.</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Categoría</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Suc y Cat.</v-tab>
		          <v-tab>Teacher y Categoría</v-tab>
		          <v-tab>Comentarios</v-tab>
		          <v-tab>Avance</v-tab>
		          <v-tab>Faltantes</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Preguntas</v-tab>
		        </v-tabs>

				

				

		        <v-tabs-items v-if="!modoSoloAvance" v-model="tab">

		        	<!-- Nivel y Cat. -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersNivel"
						          :items="nivel"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Categoria -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersCategoria"
						          :items="categorias"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Suc y Cat -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersDepartamento"
						          :items="departamentos"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Teacher y Categoria -->
				      <v-tab-item>
				        <v-card flat>
				        	<v-card-title primary-title>
				        	  Competencia de los profesores: ¿Qué tan preparados y capacitados consideras que están los profesores para enseñar el idioma inglés?
				        	</v-card-title>
				          <v-card-text>
						        <v-data-table
						          :headers="headersTeachers"
						          :items="teachers"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comentarios -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersComentario"
						          :items="comentarios"
						          class="elevation-0"
						          dense
						          :search="search"
											no-data-text="Sin comentarios abiertos"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Avance -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>
				          	<v-row class="mb-2">
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
				          				<div class="text-caption text-center">Contestaron</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
				          				<div class="text-caption text-center">Pendientes</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
				          				<div class="text-caption text-center">Con incidencia</div>
				          			</v-card>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersAvance"
						          :items="avanceAlumnos"
						          class="elevation-0"
						          dense
						          :search="search"
						          item-key="id_alumno"
						          no-data-text="Sin alumnos para el filtro seleccionado"
						        >
						        	<template v-slot:item.encuestado="{ item }">
						        		<v-btn
						        			small
						        			tile
						        			:color="item.encuestado ? 'success' : 'orange darken-1'"
						        			dark
						        			disabled
						        			class="avance-estatus-btn"
						        		>
						        			<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
						        			{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
						        		</v-btn>
						        	</template>
						        	<template v-slot:item.incidencia="{ item }">
						        		<div v-if="item.encuestado" class="text-caption grey--text">—</div>
						        		<div v-else-if="item.id_incidencia" class="d-flex align-center flex-wrap">
						        			<v-btn
						        				small
						        				tile
						        				color="teal"
						        				dark
						        				@click="abrirIncidencia( item, true )"
						        			>
						        				<v-icon left small>mdi-file-document-check</v-icon>
						        				Ver incidencia
						        			</v-btn>
						        		</div>
						        		<v-btn
						        			v-else
						        			small
						        			tile
						        			outlined
						        			color="orange darken-2"
						        			@click="abrirIncidencia( item, false )"
						        		>
						        			<v-icon left small>mdi-alert-circle-outline</v-icon>
						        			Registrar
						        		</v-btn>
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Faltantes -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-row>
				          		<v-col cols="12">
				          			<div>
				          				<b>Total: {{ alumnos }}</b><br/>
				          				<b>Faltan: {{ faltantes.length }}</b><br/>
				          				<b>Avance: {{ avanceFaltantes }} % </b>
				          				<span v-if="cicloSiguiente" class="d-block text-caption mt-1">
				          					Estatus sig. ciclo referencia: {{ cicloSiguiente }}
				          				</span>
				          			</div>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersFaltantes"
						          :items="faltantes"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        	<template v-slot:item.estatus_siguiente_ciclo="{ item }">
						        		<div class="estatus-ciclo-cell">
							        		<v-chip
							        			small
							        			label
							        			class="estatus-ciclo-chip ma-0"
							        			:color="item.en_siguiente_ciclo ? 'green lighten-4' : 'grey lighten-4'"
							        			:text-color="item.en_siguiente_ciclo ? 'green darken-3' : 'grey darken-2'"
							        			:title="item.estatus_siguiente_ciclo"
							        		>
							        			<v-icon
							        				left
							        				x-small
							        				:color="item.en_siguiente_ciclo ? 'green darken-2' : 'grey darken-1'"
							        			>
							        				{{ item.en_siguiente_ciclo ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
							        			</v-icon>
							        			{{ etiquetaEstatusSiguienteCiclo( item ) }}
							        		</v-chip>
						        		</div>
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

					  <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>

							<div style="display: flex;">

								<v-select
									style="max-width: 10rem; margin-right: 2rem;"
									  v-model="categoriaSeleccionada"
									  :items="categoriasFiltradas"
									  label="Filtrar por categoría"
									  clearable
									  dense
									  class="mb-3"
								/>
	
								<v-select
									style="max-width: 10rem;"
									  v-model="nivelSeleccionado"
									  :items="nivelesFiltradas"
									  label="Filtrar por nivel"
									  clearable
									  dense
									  class="mb-3"
								/>

							</div>

							<v-data-table
								:headers="headersPreguntas"
								:items="preguntasFiltradas"
								class="elevation-0"
								dense
							>
							</v-data-table>
							
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				</v-tabs-items>

				<!-- Vista restringida: solo Avance (Recepción / Programador de producto) -->
				<v-card v-if="modoSoloAvance" flat>
					<v-card-text>
						<v-row class="mb-2">
							<v-col cols="12" sm="4" md="3">
								<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
									<div class="text-caption text-center">Contestaron</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
									<div class="text-caption text-center">Pendientes</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
									<div class="text-caption text-center">Con incidencia</div>
								</v-card>
							</v-col>
						</v-row>
						<v-data-table
							:headers="headersAvance"
							:items="avanceAlumnos"
							class="elevation-0"
							dense
							:search="search"
							item-key="id_alumno"
							no-data-text="Sin alumnos para el filtro seleccionado"
						>
							<template v-slot:item.encuestado="{ item }">
								<v-btn
									small
									tile
									:color="item.encuestado ? 'success' : 'orange darken-1'"
									dark
									disabled
									class="avance-estatus-btn"
								>
									<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
									{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
								</v-btn>
							</template>
							<template v-slot:item.incidencia="{ item }">
								<div v-if="item.encuestado" class="text-caption grey--text">—</div>
								<div v-else-if="item.id_incidencia">
									<v-btn
										small
										tile
										color="teal"
										dark
										@click="abrirIncidencia( item, true )"
									>
										<v-icon left small>mdi-file-document-check</v-icon>
										Ver incidencia
									</v-btn>
								</div>
								<v-btn
									v-else
									small
									tile
									outlined
									color="orange darken-2"
									@click="abrirIncidencia( item, false )"
								>
									<v-icon left small>mdi-alert-circle-outline</v-icon>
									Registrar
								</v-btn>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>



		      </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<!-- Dialog reporte por sucursal -->
		<v-dialog v-model="dialogAvanceSucursal" max-width="900px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Avance por sucursal
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						dark
						small
						:disabled="!avancePorSucursal.length"
						@click="exportarExcelAvanceSucursal()"
					>
						<v-icon small left>mdi-microsoft-excel</v-icon>
						Excel
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-data-table
						:headers="headersAvanceSucursal"
						:items="avancePorSucursal"
						class="elevation-0"
						dense
						hide-default-footer
						:items-per-page="-1"
					>
						<template v-slot:item.avance="{ item }">
							{{ formatearNumero( item.avance ) }} %
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogAvanceSucursal = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog incidencia alumno sin encuesta -->
		<v-dialog v-model="dialogIncidencia" max-width="560px" persistent scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					{{ incidenciaSoloLectura ? 'Incidencia registrada' : 'Registrar incidencia' }}
					<v-spacer></v-spacer>
					<v-btn icon small @click="cerrarIncidencia()"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-card-text v-if="alumnoIncidencia">
					<div class="mb-3">
						<div class="font-weight-medium">{{ alumnoIncidencia.alumno }}</div>
						<div class="text-caption">{{ alumnoIncidencia.plantel }} · {{ alumnoIncidencia.grupo }}</div>
					</div>
					<v-textarea
						v-model="formIncidencia.comentario"
						filled
						dense
						hide-details
						label="Motivo / comentario"
						:readonly="incidenciaSoloLectura"
						rows="3"
						class="mb-3"
					></v-textarea>
					<div v-if="!incidenciaSoloLectura">
						<v-file-input
							v-model="formIncidencia.archivo"
							filled
							dense
							hide-details
							accept="image/png, image/jpeg, image/bmp, image/webp"
							prepend-icon="mdi-camera"
							label="Evidencia (1 imagen)"
							@change="previsualizarIncidencia()"
						></v-file-input>
						<v-card v-if="formIncidencia.preview" class="mt-3 pa-2" flat outlined>
							<v-img :src="formIncidencia.preview" contain max-height="220"></v-img>
						</v-card>
					</div>
					<div v-else-if="formIncidencia.evidenciaUrl">
						<div class="text-caption mb-1">Evidencia</div>
						<v-card class="pa-2" flat outlined>
							<v-img :src="formIncidencia.evidenciaUrl" contain max-height="220" @click="dialogImagenIncidencia = true" style="cursor:pointer"></v-img>
						</v-card>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="cerrarIncidencia()">Cerrar</v-btn>
					<v-btn
						v-if="!incidenciaSoloLectura"
						color="success"
						dark
						tile
						small
						:loading="guardandoIncidencia"
						:disabled="!puedeGuardarIncidencia"
						@click="guardarIncidencia()"
					>
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogImagenIncidencia" max-width="900px">
			<v-card v-if="formIncidencia.evidenciaUrl">
				<v-img :src="formIncidencia.evidenciaUrl" contain max-height="80vh"></v-img>
			</v-card>
		</v-dialog>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';

	import validarErrores       from '@/mixins/validarErrores'
	import XLSX                 from 'xlsx'
	import funcionesExcel       from '@/mixins/funcionesExcel'
	import mixinNominaSabatina  from '@/mixins/mixinNominaSabatina'
	import mixinNominaQuincena  from '@/mixins/mixinNominaQuincena'

	const PUESTOS_SOLO_AVANCE_SATISFACCION = [19, 52]

	export default {
		components:{
			Alerta,
			carga,
		},

		mixins: [ validarErrores, funcionesExcel, mixinNominaSabatina, mixinNominaQuincena ],

		data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

	  preguntas: [],
	  nivelSeleccionado: '',
	  categoriaSeleccionada: '',

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      headers1: [
        { text: 'id'                , value: 'id_teacher'           },
        { text: 'Teacher'           , value: 'teacher'              },  
        { text: 'Categoría'         , value: 'aceptado'             },  
        { text: 'HSBC'              , value: 'hsbc'                 },  
        { text: 'Plantel'           , value: 'plantel'              },  
	      { text: 'existeCategoria'   , value: 'existeCategoria'      },  
        { text: 'PAGO_SABADO'       , value: 'PAGO_SABADO', align: 'end'},  
      ],

      headersCategoria: [
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersComentario:[
        { text: 'Plantel'           , value: 'plantel'            },
        { text: 'Nivel'             , value: 'nivel'              },
        { text: 'Alumno'            , value: 'alumno'             },
      	{ text: 'Categoría'         , value: 'categoria'          },  
        { text: 'Pregunta'          , value: 'pregunta'           },
        { text: 'Comentario'        , value: 'comentario'         },  
      ],

      headersAvance: [
      	{ text: 'Plantel'    , value: 'plantel'     },
      	{ text: 'Nivel'      , value: 'nivel'       },
      	{ text: 'Grupo'      , value: 'grupo'       },
      	{ text: 'Alumno'     , value: 'alumno'      },
      	{ text: 'Encuesta'   , value: 'encuestado'  , sortable: false, align: 'center', width: '140px' },
      	{ text: 'Incidencia' , value: 'incidencia'  , sortable: false, align: 'center', width: '160px' },
      ],

      headersFaltantes:[
      	{ text: 'Nombre'         , value: 'alumno'                },
      	{ text: 'Grupo'          , value: 'grupo'                 },
      	{ text: 'Plantel'        , value: 'plantel'               },
      	{ text: 'Sig. ciclo'     , value: 'estatus_siguiente_ciclo', width: '120px', align: 'center', sortable: false },
      ],

      headersAvanceSucursal: [
      	{ text: 'Sucursal'     , value: 'plantel'     },
      	{ text: 'Total'        , value: 'total'       , align: 'end' },
      	{ text: 'Encuestados'  , value: 'encuestados' , align: 'end' },
      	{ text: 'Faltan'       , value: 'faltan'      , align: 'end' },
      	{ text: 'Avance (%)'   , value: 'avance'      , align: 'end' },
      ],


			headersJefe: [
        { text: 'Jefe'            , value: 'nombre_completo'     },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
      ],


      headersEscuela: [
        { text: 'Escuela'         , value: 'unidad_negocio'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
      ],

      headersDepartamento: [
        { text: 'Plantel'         , value: 'plantel'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersNivel: [
        { text: 'Nivel'           , value: 'nivel'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersTeachers: [
        { text: 'Teacher'         , value: 'nombre_completo'     },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

	  headersPreguntas: [
		{ text: 'Categoría'       , value: 'categoria'	},
		{ text: 'Plantel'       	  , value: 'plantel'	},
		{ text: 'Nivel'       	  , value: 'nivel'		},
		{ text: 'Pregunta'        , value: 'pregunta'	},
        { text: 'Valor'			  , value: 'valor'		}, 
      ],

      search:'',
      data:[],

      tab: 0,
	  ciclos:[],
      ciclo:null,
      faltantes:[],
			avancePorSucursal:[],
			cicloSiguiente: null,
			dialogAvanceSucursal: false,
			alumnosLista:[],
			categorias:[],
			comentarios:[],
			jefe:[],
			escuela:[],
			opEscuela: 1,
			departamentos:[],
			nivel:[],
			teachers:[],
			alumnos:0,
			planteles:[],
			niveles:[],
			filtroPlantel:null,
			filtroNivelReporte:null,
			avanceAlumnos: [],
			dialogIncidencia: false,
			dialogImagenIncidencia: false,
			incidenciaSoloLectura: false,
			alumnoIncidencia: null,
			guardandoIncidencia: false,
			urlEvidencia: '',
			formIncidencia: {
				comentario: '',
				archivo: null,
				preview: '',
				evidenciaUrl: '',
			},
			resumen:{
				promedio_general: 0,
				respuestas_obtenidas: 0,
				alumnos_encuestados: 0,
				total_alumnos: 0,
				porcentaje_participacion: 0,
				peor_categoria: null,
				mejor_categoria: null,
				sucursal_critica: null,
			},
		}),

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			tieneAccesoReporteSatisfaccion () {
				const u = this.getdatosUsuarioERPERP || {}
				const idpuesto = Number( u.idpuesto )
				const idUsuario = Number(
					u.id_usuario != null && u.id_usuario !== ''
						? u.id_usuario
						: u.iderp
				)
				if ( idpuesto === 88 && idUsuario !== 1312 ) return false
				return true
			},

			modoSoloAvance () {
				const idpuesto = Number( this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto )
				return PUESTOS_SOLO_AVANCE_SATISFACCION.includes( idpuesto )
			},

			promedioGeneralNumero () {
				return Number( this.resumen.promedio_general ) || 0
			},

			promedioGeneralDisplay () {
				return this.formatearNumero( this.promedioGeneralNumero )
			},

			porcentajeParticipacionDisplay () {
				return this.formatearNumero( this.resumen.porcentaje_participacion )
			},

			semaforoPromedioGeneral () {
				return this.semaforoPromedio( this.promedioGeneralNumero )
			},

			peorCategoriaDisplay () {
				return this.resumenConPromedio( this.resumen.peor_categoria, 'categoria' )
			},

			mejorCategoriaDisplay () {
				return this.resumenConPromedio( this.resumen.mejor_categoria, 'categoria' )
			},

			sucursalCriticaDisplay () {
				return this.resumenConPromedio( this.resumen.sucursal_critica, 'plantel' )
			},

			categoriasFiltradas () {
				return [...new Set(this.preguntas.map(p => p.categoria))]
			},

			nivelesFiltradas () {
				return [...new Set(this.preguntas.map(p => p.nivel))]
			},

			preguntasFiltradas () {
				return this.preguntas.filter(p => {
				const coincideCategoria =
					!this.categoriaSeleccionada ||
					p.categoria === this.categoriaSeleccionada

				const coincideNivel =
					!this.nivelSeleccionado ||
					p.nivel === this.nivelSeleccionado

				return coincideCategoria && coincideNivel
				})
			},

			tieneDatosReporte () {
				return [
					this.nivel,
					this.categorias,
					this.departamentos,
					this.teachers,
					this.faltantes,
					this.preguntas,
					this.comentarios,
					this.avanceAlumnos,
				].some( items => Array.isArray( items ) && items.length )
			},

			avanceFaltantes () {
				const total = Number( this.alumnos ) || 0
				const falta = ( this.faltantes && this.faltantes.length ) || 0
				if ( !total ) return '0.00'
				const respondieron = total - falta
				return ( ( respondieron / total ) * 100 ).toFixed( 2 )
			},

			cicloSiguienteCorto () {
				if ( !this.cicloSiguiente ) return ''
				const match = String( this.cicloSiguiente ).match( /(\d{1,2}_\d{2})/ )
				return match ? match[1] : String( this.cicloSiguiente ).replace( /CICLO\s*/i, '' ).trim()
			},

			avanceConteo () {
				const lista = this.avanceAlumnos || []
				const encuestados = lista.filter( a => Number( a.encuestado ) === 1 ).length
				const pendientes = lista.length - encuestados
				const incidencias = lista.filter( a => a.id_incidencia ).length
				return { encuestados, pendientes, incidencias }
			},

			puedeGuardarIncidencia () {
				return !!(
					this.formIncidencia.comentario
					&& this.formIncidencia.comentario.trim()
					&& this.formIncidencia.archivo
					&& !this.guardandoIncidencia
				)
			},

			headersAvanceExcel () {
				return [
					{ text: 'Plantel', value: 'plantel' },
					{ text: 'Nivel', value: 'nivel' },
					{ text: 'Grupo', value: 'grupo' },
					{ text: 'Alumno', value: 'alumno' },
					{ text: 'Encuesta', value: 'encuesta_texto' },
					{ text: 'Incidencia', value: 'incidencia_texto' },
				]
			},

			avanceAlumnosExcel () {
				return ( this.avanceAlumnos || [] ).map( row => ( {
					...row,
					encuesta_texto: Number( row.encuestado ) === 1 ? 'Contestó' : 'Pendiente',
					incidencia_texto: row.id_incidencia ? ( row.incidencia_comentario || 'Registrada' ) : '',
				} ) )
			},

		},

		watch: {
			ciclo( value ){

				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( value && this.opEscuela ){ this.initialize() }

			},


			opEscuela( value ){

				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( value && this.ciclo ){ this.initialize() }

			},

			filtroPlantel () {
				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( this.ciclo ){ this.initialize() }
			},

			filtroNivelReporte () {
				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( this.ciclo ){ this.initialize() }
			}
		},

		async created () {
			if ( !this.tieneAccesoReporteSatisfaccion ) return
			this.urlEvidencia = axios.defaults.baseURL + 'evidencia-tickets/'
    	await this.getCiclos()
		},

		methods:{

			etiquetaEstatusSiguienteCiclo ( item ) {
				if ( item.en_siguiente_ciclo ) {
					return this.cicloSiguienteCorto || 'Sí'
				}
				return 'No'
			},

			formatearNumero ( valor ) {
				const numero = Number( valor )
				if ( !Number.isFinite( numero ) ) return '0.00'
				return numero.toFixed( 2 )
			},

			semaforoPromedio ( valor ) {
				const promedio = Number( valor )
				if ( !Number.isFinite( promedio ) || promedio <= 0 ) {
					return { color: 'grey', background: 'grey lighten-4', label: 'Sin datos' }
				}
				if ( promedio < 8 ) return { color: 'red', background: 'red lighten-5', label: 'Rojo' }
				if ( promedio < 9 ) return { color: 'amber darken-2', background: 'amber lighten-5', label: 'Amarillo' }
				return { color: 'green', background: 'green lighten-5', label: 'Verde' }
			},

			resumenConPromedio ( item, campo ) {
				if ( !item || !item[campo] ) return 'Sin datos'
				return `${ item[campo] } (${ this.formatearNumero( item.promedio ) })`
			},

			resumenDefault () {
				return {
					promedio_general: 0,
					respuestas_obtenidas: 0,
					alumnos_encuestados: 0,
					total_alumnos: 0,
					porcentaje_participacion: 0,
					peor_categoria: null,
					mejor_categoria: null,
					sucursal_critica: null,
				}
			},

			plantelSeleccionadoTexto () {
				const plantel = this.planteles.find( item => Number( item.id_plantel ) === Number( this.filtroPlantel ) )
				return plantel ? plantel.plantel : 'Todos'
			},

			nivelSeleccionadoTexto () {
				const nivel = this.niveles.find( item => Number( item.id_nivel ) === Number( this.filtroNivelReporte ) )
				return nivel ? nivel.nivel : 'Todos'
			},

			/** id_ciclo ERP según escuela (Inbi vs Fast); acepta objeto ciclo o solo el id numérico */
			idCicloEncuestaSeleccionado () {
				const c = this.ciclo
				if ( c == null || c === '' ) return null
				if ( typeof c === 'number' ) return Number.isFinite( c ) && c > 0 ? c : null
				const idInbi = Number( c.id_ciclo )
				const idRel = c.id_ciclo_relacionado != null && c.id_ciclo_relacionado !== ''
					? Number( c.id_ciclo_relacionado )
					: null
				if ( this.opEscuela === 2 ) {
					if ( Number.isFinite( idRel ) && idRel > 0 ) return idRel
					return Number.isFinite( idInbi ) && idInbi > 0 ? idInbi : null
				}
				return Number.isFinite( idInbi ) && idInbi > 0 ? idInbi : null
			},

   		getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data.filter( el => !el.ciclo.match('FE') && !el.ciclo.match('INVER') && !el.ciclo.match('CAMBIOS') && !el.ciclo.match('EXCI') )
        	this.cargar      = false
        }).catch( error =>{
          const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar ciclos'
          this.validarError( msg )
        }).finally( () => { this.cargar = false })
      },

			exportarExcelReporte () {
				if ( !this.tieneDatosReporte ) {
					this.validarErrorDirecto( 'No hay datos para exportar.' )
					return
				}

				const workbook = XLSX.utils.book_new()
				const hojas = [
					{
						nombre: 'Resumen',
						datos: [ {
							Ciclo: this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : '',
							Escuela: this.opEscuela === 2 ? 'Fast' : 'Inbi',
							'Sucursal filtro': this.plantelSeleccionadoTexto(),
							'Nivel filtro': this.nivelSeleccionadoTexto(),
							'Promedio general': this.promedioGeneralDisplay,
							'Semáforo': this.semaforoPromedioGeneral.label,
							'Participación (%)': this.porcentajeParticipacionDisplay,
							'Peor categoría': this.peorCategoriaDisplay,
							'Mejor categoría': this.mejorCategoriaDisplay,
							'Sucursal crítica': this.sucursalCriticaDisplay,
							'Respuestas obtenidas': this.resumen.respuestas_obtenidas,
							Total: this.alumnos,
							Faltan: this.faltantes.length,
							'Avance (%)': this.avanceFaltantes,
						} ],
					},
					{ key: 'nivel', nombre: 'Nivel y Cat', headers: this.headersNivel, datos: this.mapearDatosExcel( this.headersNivel, this.nivel ) },
					{ key: 'categorias', nombre: 'Categoria', headers: this.headersCategoria, datos: this.mapearDatosExcel( this.headersCategoria, this.categorias ) },
					{ key: 'departamentos', nombre: 'Suc y Cat', headers: this.headersDepartamento, datos: this.mapearDatosExcel( this.headersDepartamento, this.departamentos ) },
					{ key: 'teachers', nombre: 'Teacher y Categoria', headers: this.headersTeachers, datos: this.mapearDatosExcel( this.headersTeachers, this.teachers ) },
					{ key: 'comentarios', nombre: 'Comentarios', headers: this.headersComentario, datos: this.mapearDatosExcel( this.headersComentario, this.comentarios ) },
					{ key: 'avance', nombre: 'Avance', headers: this.headersAvanceExcel, datos: this.mapearDatosExcel( this.headersAvanceExcel, this.avanceAlumnosExcel ) },
					{ key: 'faltantes', nombre: 'Faltantes', headers: this.headersFaltantes, datos: this.mapearDatosExcel( this.headersFaltantes, this.faltantes ) },
					{ key: 'avanceSucursal', nombre: 'Avance sucursal', headers: this.headersAvanceSucursal, datos: this.mapearDatosExcel( this.headersAvanceSucursal, this.avancePorSucursal ) },
					{ key: 'preguntas', nombre: 'Preguntas', headers: this.headersPreguntas, datos: this.mapearDatosExcel( this.headersPreguntas, this.preguntas ) },
				]

				hojas.forEach( hoja => {
					const headers = hoja.headers ? hoja.headers.map( header => header.text ) : null
					const sheet = headers
						? XLSX.utils.json_to_sheet( hoja.datos, { header: headers } )
						: XLSX.utils.json_to_sheet( hoja.datos )
					XLSX.utils.book_append_sheet( workbook, sheet, hoja.nombre )
				} )

				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `reporte_satisfaccion_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			exportarExcelAvanceSucursal () {
				if ( !this.avancePorSucursal.length ) {
					this.validarErrorDirecto( 'No hay datos de sucursales para exportar.' )
					return
				}
				const workbook = XLSX.utils.book_new()
				const datos = this.mapearDatosExcel( this.headersAvanceSucursal, this.avancePorSucursal )
				const headers = this.headersAvanceSucursal.map( header => header.text )
				const sheet = XLSX.utils.json_to_sheet( datos, { header: headers } )
				XLSX.utils.book_append_sheet( workbook, sheet, 'Avance sucursal' )
				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `avance_satisfaccion_sucursal_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			mapearDatosExcel ( headers, items ) {
				return ( items || [] ).map( item => {
					return headers.reduce( ( row, header ) => {
						row[ header.text ] = this.valorExcel( item[ header.value ], header.value )
						return row
					}, {} )
				} )
			},

			valorExcel ( valor, campo ) {
				if ( valor == null ) return ''
				if ( campo === 'promedio' ) {
					if ( String( valor ).toLowerCase() === 'no aplica' ) return 'No aplica'
					const numero = Number( valor )
					return Number.isFinite( numero ) ? numero : valor
				}
				if ( campo === 'avance' ) {
					const numero = Number( valor )
					return Number.isFinite( numero ) ? numero : valor
				}
				return valor
			},

			initialize ( ) {
				if ( !this.tieneAccesoReporteSatisfaccion ) return
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido (id de ciclo no disponible).' )
					return
				}
				this.cargar = true
				const payload = {
          id_ciclo : idCiclo,
          iderp    : this.getdatosUsuarioERPERP.iderp,
          idpuesto : this.getdatosUsuarioERPERP.idpuesto,
          planteles: this.getdatosUsuarioERPERP.planteles,
					op_escuela: this.opEscuela,
					id_plantel: this.filtroPlantel || null,
					id_nivel: this.filtroNivelReporte || null,
        };

				this.$http.post('encuestas.satisfaccion.resultados', payload).then(response=>{
					const d = response.data || {}
					if ( this.modoSoloAvance ) {
						this.avanceAlumnos = Array.isArray( d.avanceAlumnos ) ? d.avanceAlumnos : []
						this.planteles = Array.isArray( d.planteles ) ? d.planteles : []
						this.niveles = Array.isArray( d.niveles ) ? d.niveles : []
						this.faltantes = []
						this.categorias = []
						this.comentarios = []
						this.jefe = []
						this.escuela = []
						this.departamentos = []
						this.nivel = []
						this.preguntas = []
						this.teachers = []
						this.alumnosLista = []
						this.alumnos = Number( d.alumnos ) || this.avanceAlumnos.length
						this.avancePorSucursal = []
						this.cicloSiguiente = null
						this.resumen = Object.assign( this.resumenDefault(), d.resumen || {} )
						return
					}
					this.faltantes     = Array.isArray( d.faltantes ) ? d.faltantes : []
					this.categorias    = Array.isArray( d.categorias ) ? d.categorias : []
					this.comentarios   = Array.isArray( d.comentarios ) ? d.comentarios : []
					this.avanceAlumnos = Array.isArray( d.avanceAlumnos ) ? d.avanceAlumnos : []
					this.jefe          = Array.isArray( d.jefe ) ? d.jefe : []
					this.escuela       = Array.isArray( d.escuela ) ? d.escuela : []
					this.departamentos = Array.isArray( d.departamentos ) ? d.departamentos : []
					this.nivel         = Array.isArray( d.nivel ) ? d.nivel : []
					this.preguntas     = Array.isArray( d.preguntasAlumnos ) ? d.preguntasAlumnos : []
					this.teachers      = Array.isArray( d.teachers ) ? d.teachers : []
					this.alumnosLista  = Array.isArray( d.alumnos ) ? d.alumnos : []
					this.alumnos       = this.alumnosLista.length
					this.avancePorSucursal = Array.isArray( d.avancePorSucursal ) ? d.avancePorSucursal : []
					this.cicloSiguiente = d.ciclo_siguiente || null
					this.planteles     = Array.isArray( d.planteles ) ? d.planteles : []
					this.niveles       = Array.isArray( d.niveles ) ? d.niveles : []
					this.resumen       = Object.assign( this.resumenDefault(), d.resumen || {} )
				}).catch( error =>{
					const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar el reporte'
					this.validarError( msg )
				}).finally( () => { this.cargar = false })	
			},

			abrirIncidencia ( item, soloLectura ) {
				this.alumnoIncidencia = item
				this.incidenciaSoloLectura = soloLectura
				this.formIncidencia = {
					comentario: item.incidencia_comentario || '',
					archivo: null,
					preview: '',
					evidenciaUrl: item.incidencia_evidencia
						? this.urlEvidencia + item.incidencia_evidencia
						: '',
				}
				this.dialogIncidencia = true
			},

			cerrarIncidencia () {
				this.dialogIncidencia = false
				this.alumnoIncidencia = null
				this.incidenciaSoloLectura = false
				this.formIncidencia = {
					comentario: '',
					archivo: null,
					preview: '',
					evidenciaUrl: '',
				}
			},

			previsualizarIncidencia () {
				const archivo = this.formIncidencia.archivo
				if ( !archivo ) {
					this.formIncidencia.preview = ''
					return
				}
				if ( archivo.size > 26214400 ) {
					this.validarErrorDirecto( 'El archivo sobrepasa el límite de peso, máx. 25 MB' )
					this.formIncidencia.archivo = null
					this.formIncidencia.preview = ''
					return
				}
				const reader = new FileReader()
				reader.onload = ( e ) => {
					this.formIncidencia.preview = e.target.result
				}
				reader.readAsDataURL( archivo )
			},

			subirEvidenciaIncidencia () {
				const formData = new FormData()
				formData.append( 'file', this.formIncidencia.archivo )
				return this.$http.post( 'tickets.subir.evidencia', formData ).then( response => {
					const nombres = Array.isArray( response.data ) ? response.data : []
					if ( !nombres.length ) {
						throw new Error( 'No se pudo subir la evidencia' )
					}
					return nombres[0]
				} )
			},

			async guardarIncidencia () {
				if ( !this.puedeGuardarIncidencia || !this.alumnoIncidencia ) return
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido.' )
					return
				}
				this.guardandoIncidencia = true
				try {
					const evidencia = await this.subirEvidenciaIncidencia()
					const payload = {
						id_ciclo: idCiclo,
						id_alumno: this.alumnoIncidencia.id_alumno,
						comentario: this.formIncidencia.comentario.trim(),
						evidencia,
						id_usuario: this.getdatosUsuarioERPERP.iderp,
					}
					const response = await this.$http.post( 'encuestas.satisfaccion.incidencia.add', payload )
					const inc = response.data && response.data.incidencia ? response.data.incidencia : null
					const idx = this.avanceAlumnos.findIndex(
						a => Number( a.id_alumno ) === Number( this.alumnoIncidencia.id_alumno )
					)
					if ( idx >= 0 && inc ) {
						this.$set( this.avanceAlumnos, idx, {
							...this.avanceAlumnos[idx],
							id_incidencia: inc.id_incidencia,
							incidencia_comentario: inc.comentario,
							incidencia_evidencia: inc.evidencia,
							incidencia_fecha: inc.fecha_registro,
						} )
					}
					this.validarSuccess( response.data.message || 'Incidencia registrada' )
					this.cerrarIncidencia()
				} catch ( error ) {
					const msg = ( error.response && error.response.data && error.response.data.message )
						|| error.message
						|| 'Error al guardar la incidencia'
					this.validarError( msg )
				} finally {
					this.guardandoIncidencia = false
				}
			},
    }
	}
</script>

<style scoped>
.estatus-ciclo-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 96px;
}

.estatus-ciclo-chip {
  font-size: 0.75rem !important;
  font-weight: 600;
  height: 24px !important;
  padding: 0 8px !important;
}

.estatus-ciclo-chip >>> .v-chip__content {
  padding: 0;
  line-height: 1;
}

.avance-estatus-btn.v-btn--disabled {
  opacity: 1 !important;
}
</style>



